import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  plus1ogy4liedzq5j as plus,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  VOID3gxj6tk5isa35 as VOID,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$33ewqhqmjrfx6 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  Collection1k04j3hzsbod0 as Collection,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  Unitkvevlwgzwiuc as Unit,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$_0,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  getKClass3t8tygqu4lcxf as getKClass,
  setOf45ia9pnfhe90 as setOf,
  KtList3hktaavzmj137 as KtList,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  endsWith3cq61xxngobwh as endsWith,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Application_getInstanceq87g3bor693u as Application_getInstance,
  contentType317fn4f991q9a as contentType,
  HttpHeaders_getInstanceelogg8fjd54u as HttpHeaders_getInstance,
  Companion_getInstancecf9b3ybko8sp as Companion_getInstance,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  contentType2zzm38yxo3syt as contentType_0,
  charset1dribv3ku48b1 as charset,
  NullBody_instance2i6w0hfghwfg0 as NullBody_instance,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
  ContentType1svlpabm9v7iz as ContentType,
} from './ktor-ktor-http.mjs';
import {
  register$default3vdkjcc7m2cj0 as register$default,
  Configuration20xgygxdzhlk5 as Configuration,
  suitableCharset1jgdcpdzbzgzn as suitableCharset,
  deserialize3kqe4vxpbxz1 as deserialize,
} from './ktor-ktor-serialization.mjs';
import {
  Charsets_getInstanceqs70pvl4noow as Charsets_getInstance,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ktor-ktor-io.mjs';
import {
  TransformRequestBodyContext3ll40opqaho0d as TransformRequestBodyContext,
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  TransformResponseBodyContext1axf7xx6ifwbj as TransformResponseBodyContext,
  HttpResponse1532ob1hsse1y as HttpResponse,
  get_request3dwcif5y0fvf1 as get_request,
  accept2gi3b7wj4jds9 as accept,
  EmptyContent_getInstance116ybdh9l8hek as EmptyContent_getInstance,
  ClientSSESession332rusa1q4gim as ClientSSESession,
  ClientSSESessionWithDeserialization37nab8162l18r as ClientSSESessionWithDeserialization,
  createClientPluginjwpvufjows5r as createClientPlugin,
} from './ktor-ktor-client-core.mjs';
import {
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from './ktor-ktor-utils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
initMetadataForClass(ContentNegotiationConfig$defaultMatcher$1);
initMetadataForClass(ContentNegotiationConfig, 'ContentNegotiationConfig', ContentNegotiationConfig, VOID, [Configuration]);
initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
initMetadataForLambda(ContentNegotiation$lambda$slambda, CoroutineImpl, VOID, [4]);
initMetadataForLambda(ContentNegotiation$lambda$slambda_1, CoroutineImpl, VOID, [4]);
initMetadataForCoroutine($invoke$convertRequestCOROUTINE$, CoroutineImpl);
initMetadataForCoroutine($invoke$convertResponseCOROUTINE$, CoroutineImpl);
initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
//endregion
function get_LOGGER() {
  _init_properties_ContentNegotiation_kt__o183go();
  return LOGGER;
}
var LOGGER;
function get_DefaultCommonIgnoredTypes() {
  _init_properties_ContentNegotiation_kt__o183go();
  return DefaultCommonIgnoredTypes;
}
var DefaultCommonIgnoredTypes;
function get_ExcludedContentTypes() {
  _init_properties_ContentNegotiation_kt__o183go();
  return ExcludedContentTypes;
}
var ExcludedContentTypes;
function get_ContentNegotiation() {
  _init_properties_ContentNegotiation_kt__o183go();
  return ContentNegotiation;
}
var ContentNegotiation;
function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
  this.v60_1 = converter;
  this.w60_1 = contentTypeToSend;
  this.x60_1 = contentTypeMatcher;
}
function defaultMatcher($this, pattern) {
  return new ContentNegotiationConfig$defaultMatcher$1(pattern);
}
function ContentNegotiationConfig$defaultMatcher$1($pattern) {
  this.y60_1 = $pattern;
}
protoOf(ContentNegotiationConfig$defaultMatcher$1).z60 = function (contentType) {
  return contentType.g34(this.y60_1);
};
function ContentNegotiationConfig() {
  this.a61_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.b61_1 = ArrayList_init_$Create$();
  this.c61_1 = null;
}
protoOf(ContentNegotiationConfig).i4g = function (contentType, converter, configuration) {
  var matcher = contentType.g34(Application_getInstance().m32_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
  this.d61(contentType, converter, matcher, configuration);
};
protoOf(ContentNegotiationConfig).d61 = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
  // Inline function 'kotlin.apply' call
  configuration(converter);
  var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
  this.b61_1.j(registration);
};
function ContentConverterException(message) {
  Exception_init_$Init$(message, this);
  captureStack(this, ContentConverterException);
}
function ContentNegotiationConfig$_init_$ref_1ne3ob() {
  var l = function () {
    return new ContentNegotiationConfig();
  };
  l.callableName = '<init>';
  return l;
}
function ContentNegotiation$lambda($this$createClientPlugin) {
  _init_properties_ContentNegotiation_kt__o183go();
  var registrations = $this$createClientPlugin.e4y_1.b61_1;
  var ignoredTypes = $this$createClientPlugin.e4y_1.a61_1;
  $this$createClientPlugin.l5i(ContentNegotiation$lambda$slambda_0(registrations, $this$createClientPlugin, ignoredTypes, null));
  $this$createClientPlugin.j57(ContentNegotiation$lambda$slambda_2(ignoredTypes, registrations, $this$createClientPlugin, null));
  return Unit_instance;
}
function invoke$convertRequest(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion) {
  var tmp = new $invoke$convertRequestCOROUTINE$(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function invoke$convertResponse(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion) {
  charset = charset === VOID ? Charsets_getInstance().g2u_1 : charset;
  var tmp = new $invoke$convertResponseCOROUTINE$(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
  this.v62_1 = $registrations;
  this.w62_1 = $this_createClientPlugin;
  this.x62_1 = $ignoredTypes;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ContentNegotiation$lambda$slambda).c63 = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
  var tmp = this.d63($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ContentNegotiation$lambda$slambda).o58 = function (p1, p2, p3, p4, $completion) {
  var tmp = p1 instanceof TransformRequestBodyContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
  var tmp_1 = !(p3 == null) ? p3 : THROW_CCE();
  return this.c63(tmp, tmp_0, tmp_1, (p4 == null ? true : p4 instanceof TypeInfo) ? p4 : THROW_CCE(), $completion);
};
protoOf(ContentNegotiation$lambda$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = invoke$convertRequest(this.v62_1, this.w62_1, this.x62_1, this.z62_1, this.a63_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(ContentNegotiation$lambda$slambda).d63 = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, completion) {
  var i = new ContentNegotiation$lambda$slambda(this.v62_1, this.w62_1, this.x62_1, completion);
  i.y62_1 = $this$transformRequestBody;
  i.z62_1 = request;
  i.a63_1 = body;
  i.b63_1 = _unused_var__etf5q3;
  return i;
};
function ContentNegotiation$lambda$slambda_0($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
  var i = new ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation);
  var l = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
    return i.c63($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
  };
  l.$arity = 4;
  return l;
}
function ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
  this.m63_1 = $ignoredTypes;
  this.n63_1 = $registrations;
  this.o63_1 = $this_createClientPlugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ContentNegotiation$lambda$slambda_1).m58 = function ($this$transformResponseBody, response, body, info, $completion) {
  var tmp = this.n58($this$transformResponseBody, response, body, info, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(ContentNegotiation$lambda$slambda_1).o58 = function (p1, p2, p3, p4, $completion) {
  var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
  var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
  return this.m58(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
};
protoOf(ContentNegotiation$lambda$slambda_1).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp0_elvis_lhs = contentType(this.q63_1);
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }

          var contentType_0 = tmp_0;
          var charset = suitableCharset(get_request(this.q63_1).q39());
          this.d8_1 = 1;
          suspendResult = invoke$convertResponse(this.m63_1, this.n63_1, this.o63_1, get_request(this.q63_1).b3p(), this.s63_1, this.r63_1, contentType_0, charset, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(ContentNegotiation$lambda$slambda_1).n58 = function ($this$transformResponseBody, response, body, info, completion) {
  var i = new ContentNegotiation$lambda$slambda_1(this.m63_1, this.n63_1, this.o63_1, completion);
  i.p63_1 = $this$transformResponseBody;
  i.q63_1 = response;
  i.r63_1 = body;
  i.s63_1 = info;
  return i;
};
function ContentNegotiation$lambda$slambda_2($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
  var i = new ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation);
  var l = function ($this$transformResponseBody, response, body, info, $completion) {
    return i.m58($this$transformResponseBody, response, body, info, $completion);
  };
  l.$arity = 4;
  return l;
}
function ContentNegotiation$lambda$convertRequest$lambda(it) {
  _init_properties_ContentNegotiation_kt__o183go();
  return toString(it.v60_1);
}
function $invoke$convertRequestCOROUTINE$(registrations, $this_createClientPlugin, ignoredTypes, request, body, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m61_1 = registrations;
  this.n61_1 = $this_createClientPlugin;
  this.o61_1 = ignoredTypes;
  this.p61_1 = request;
  this.q61_1 = body;
}
protoOf($invoke$convertRequestCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 7;
          var tmp_0;
          if (this.p61_1.i4q_1.n2v(get_ExcludedContentTypes())) {
            var excluded = this.p61_1.i4q_1.l2v(get_ExcludedContentTypes());
            var tmp0 = this.m61_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.l();
            while (_iterator__ex2g4s.m()) {
              var element = _iterator__ex2g4s.n();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_1;
                if (isInterface(excluded, Collection)) {
                  tmp_1 = excluded.q();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_0 = excluded.l();
                while (_iterator__ex2g4s_0.m()) {
                  var element_0 = _iterator__ex2g4s_0.n();
                  if (element.w60_1.g34(element_0)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = true;
              }
               while (false);
              if (tmp$ret$0) {
                destination.j(element);
              }
            }
            tmp_0 = destination;
          } else {
            tmp_0 = this.m61_1;
          }

          var requestRegistrations = tmp_0;
          var tmp0_elvis_lhs = this.p61_1.f4q_1.d2x(HttpHeaders_getInstance().l35_1);
          var acceptHeaders = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
          var _iterator__ex2g4s_1 = requestRegistrations.l();
          while (_iterator__ex2g4s_1.m()) {
            var element_1 = _iterator__ex2g4s_1.n();
            var tmp$ret$2;
            l$ret$3: do {
              var tmp_2;
              if (isInterface(acceptHeaders, Collection)) {
                tmp_2 = acceptHeaders.q();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$2 = true;
                break l$ret$3;
              }
              var _iterator__ex2g4s_2 = acceptHeaders.l();
              while (_iterator__ex2g4s_2.m()) {
                var element_2 = _iterator__ex2g4s_2.n();
                if (Companion_getInstance().in(element_2).g34(element_1.w60_1)) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = true;
            }
             while (false);
            if (tmp$ret$2) {
              var qValue = this.n61_1.e4y_1.c61_1;
              var contentTypeToSend = qValue == null ? element_1.w60_1 : element_1.w60_1.e34('q', qValue.toString());
              get_LOGGER().y31('Adding Accept=' + contentTypeToSend.toString() + ' header for ' + this.p61_1.d4q_1.toString());
              accept(this.p61_1, contentTypeToSend);
            }
          }

          var tmp_3;
          var tmp_4 = this.q61_1;
          if (tmp_4 instanceof OutgoingContent) {
            tmp_3 = true;
          } else {
            var tmp0_0 = this.o61_1;
            var tmp$ret$4;
            l$ret$5: do {
              var tmp_5;
              if (isInterface(tmp0_0, Collection)) {
                tmp_5 = tmp0_0.q();
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp$ret$4 = false;
                break l$ret$5;
              }
              var _iterator__ex2g4s_3 = tmp0_0.l();
              while (_iterator__ex2g4s_3.m()) {
                var element_3 = _iterator__ex2g4s_3.n();
                if (element_3.fa(this.q61_1)) {
                  tmp$ret$4 = true;
                  break l$ret$5;
                }
              }
              tmp$ret$4 = false;
            }
             while (false);
            tmp_3 = tmp$ret$4;
          }

          if (tmp_3) {
            get_LOGGER().y31('Body type ' + toString(getKClassFromExpression(this.q61_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.p61_1.d4q_1.toString() + '.'));
            return null;
          }

          var tmp_6 = this;
          var tmp0_elvis_lhs_0 = contentType_0(this.p61_1);
          var tmp_7;
          if (tmp0_elvis_lhs_0 == null) {
            this.n61_1;
            get_LOGGER().y31("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.p61_1.d4q_1.toString() + '.');
            return null;
          } else {
            tmp_7 = tmp0_elvis_lhs_0;
          }

          tmp_6.s61_1 = tmp_7;
          var tmp_8 = this.q61_1;
          if (tmp_8 instanceof Unit) {
            get_LOGGER().y31('Sending empty body for ' + this.p61_1.d4q_1.toString());
            this.p61_1.f4q_1.m2x(HttpHeaders_getInstance().d36_1);
            return EmptyContent_getInstance();
          }

          var tmp_9 = this;
          var tmp0_1 = this.m61_1;
          var destination_0 = ArrayList_init_$Create$();
          var _iterator__ex2g4s_4 = tmp0_1.l();
          while (_iterator__ex2g4s_4.m()) {
            var element_4 = _iterator__ex2g4s_4.n();
            if (element_4.x60_1.z60(this.s61_1)) {
              destination_0.j(element_4);
            }
          }

          var tmp_10;
          if (!destination_0.q()) {
            tmp_10 = destination_0;
          } else {
            tmp_10 = null;
          }

          var tmp1_elvis_lhs = tmp_10;
          var tmp_11;
          if (tmp1_elvis_lhs == null) {
            this.n61_1;
            get_LOGGER().y31('None of the registered converters match request Content-Type=' + this.s61_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.p61_1.d4q_1.toString() + '.'));
            return null;
          } else {
            tmp_11 = tmp1_elvis_lhs;
          }

          tmp_9.r61_1 = tmp_11;
          if (this.p61_1.r5l() == null) {
            get_LOGGER().y31('Request has unknown body type. Skipping ContentNegotiation for ' + this.p61_1.d4q_1.toString() + '.');
            return null;
          }

          this.p61_1.f4q_1.m2x(HttpHeaders_getInstance().d36_1);
          var tmp_12 = this;
          tmp_12.w61_1 = this.r61_1;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.v61_1 = this.w61_1.l();
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (!this.v61_1.m()) {
            this.d8_1 = 5;
            continue $sm;
          }

          var element_5 = this.v61_1.n();
          this.u61_1 = element_5;
          this.d8_1 = 3;
          var tmp0_elvis_lhs_1 = charset(this.s61_1);
          var tmp_13 = tmp0_elvis_lhs_1 == null ? Charsets_getInstance().g2u_1 : tmp0_elvis_lhs_1;
          var tmp_14 = ensureNotNull(this.p61_1.r5l());
          var this_0 = this.q61_1;
          var tmp_15;
          if (!equals(this_0, NullBody_instance)) {
            tmp_15 = this_0;
          } else {
            tmp_15 = null;
          }

          suspendResult = this.u61_1.v60_1.t63(this.s61_1, tmp_13, tmp_14, tmp_15, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var result = suspendResult;
          if (!(result == null)) {
            get_LOGGER().y31('Converted request body using ' + toString(this.u61_1.v60_1) + ' for ' + this.p61_1.d4q_1.toString());
          }

          var result_0 = result;
          if (!(result_0 == null)) {
            this.t61_1 = result_0;
            this.d8_1 = 6;
            continue $sm;
          } else {
            this.d8_1 = 4;
            continue $sm;
          }

        case 4:
          this.d8_1 = 2;
          continue $sm;
        case 5:
          this.t61_1 = null;
          if (false) {
            this.d8_1 = 1;
            continue $sm;
          }

          this.d8_1 = 6;
          continue $sm;
        case 6:
          var tmp2_elvis_lhs = this.t61_1;
          var tmp_16;
          if (tmp2_elvis_lhs == null) {
            var tmp_17 = "Can't convert " + toString(this.q61_1) + ' with contentType ' + this.s61_1.toString() + ' using converters ';
            throw new ContentConverterException(tmp_17 + joinToString(this.r61_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$lambda$convertRequest$lambda));
          } else {
            tmp_16 = tmp2_elvis_lhs;
          }

          var serializedContent = tmp_16;
          return serializedContent;
        case 7:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 7) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function $invoke$convertResponseCOROUTINE$(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.f62_1 = ignoredTypes;
  this.g62_1 = registrations;
  this.h62_1 = $this_createClientPlugin;
  this.i62_1 = requestUrl;
  this.j62_1 = info;
  this.k62_1 = body;
  this.l62_1 = responseContentType;
  this.m62_1 = charset;
}
protoOf($invoke$convertResponseCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          var tmp_0 = this.k62_1;
          if (!isInterface(tmp_0, ByteReadChannel)) {
            get_LOGGER().y31('Response body is already transformed. Skipping ContentNegotiation for ' + this.i62_1.toString() + '.');
            return null;
          }

          if (this.f62_1.q1(this.j62_1.r31_1)) {
            get_LOGGER().y31('Response body type ' + toString(this.j62_1.r31_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.i62_1.toString() + '.'));
            return null;
          }

          var tmp0 = this.g62_1;
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.l();
          while (_iterator__ex2g4s.m()) {
            var element = _iterator__ex2g4s.n();
            if (element.x60_1.z60(this.l62_1)) {
              destination.j(element);
            }
          }

          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.l();
          while (_iterator__ex2g4s_0.m()) {
            var item = _iterator__ex2g4s_0.n();
            destination_0.j(item.v60_1);
          }

          var tmp_1;
          if (!destination_0.q()) {
            tmp_1 = destination_0;
          } else {
            tmp_1 = null;
          }

          var tmp0_elvis_lhs = tmp_1;
          var tmp_2;
          if (tmp0_elvis_lhs == null) {
            this.h62_1;
            get_LOGGER().y31('None of the registered converters match response with Content-Type=' + this.l62_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.i62_1.toString() + '.'));
            return null;
          } else {
            tmp_2 = tmp0_elvis_lhs;
          }

          var suitableConverters = tmp_2;
          this.d8_1 = 1;
          suspendResult = deserialize(suitableConverters, this.k62_1, this.j62_1, this.m62_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          if (!isInterface(result, ByteReadChannel)) {
            get_LOGGER().y31('Response body was converted to ' + toString(getKClassFromExpression(result)) + ' for ' + this.i62_1.toString() + '.');
          }

          return result;
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_ContentNegotiation_kt_1ayduy;
function _init_properties_ContentNegotiation_kt__o183go() {
  if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
    properties_initialized_ContentNegotiation_kt_1ayduy = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
    DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().pb(), PrimitiveClasses_getInstance().lb(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent), getKClass(ClientSSESession), getKClass(ClientSSESessionWithDeserialization)]);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExcludedContentTypesAttr';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtList);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ContentType), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    ExcludedContentTypes = new AttributeKey(name, tmp$ret$1);
    var tmp_2 = ContentNegotiationConfig$_init_$ref_1ne3ob();
    ContentNegotiation = createClientPlugin('ContentNegotiation', tmp_2, ContentNegotiation$lambda);
  }
}
function JsonContentTypeMatcher() {
}
protoOf(JsonContentTypeMatcher).z60 = function (contentType) {
  if (contentType.g34(Application_getInstance().m32_1)) {
    return true;
  }
  var value = contentType.f34().toString();
  return Application_getInstance().g33(value) && endsWith(value, '+json', true);
};
var JsonContentTypeMatcher_instance;
function JsonContentTypeMatcher_getInstance() {
  return JsonContentTypeMatcher_instance;
}
function get_DefaultIgnoredTypes() {
  _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
  return DefaultIgnoredTypes;
}
var DefaultIgnoredTypes;
var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
  if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
    properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
  }
}
//region block: post-declaration
protoOf(ContentNegotiationConfig).j4g = register$default;
//endregion
//region block: init
JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
//endregion
//region block: exports
export {
  get_ContentNegotiation as get_ContentNegotiationcp59ye9rorjc,
};
//endregion

//# sourceMappingURL=ktor-ktor-client-content-negotiation.mjs.map
